import { render, staticRenderFns } from "./audiencesOverview.vue?vue&type=template&id=5327ee32&lang=pug"
import script from "./audiencesOverview.vue?vue&type=script&lang=js"
export * from "./audiencesOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports